// Account Receivable Statements Vuex

import state from './receivableStatementStates.js'
import * as getters from './receivableStatementGetters.js'
import * as mutations from './receivableStatementMutations.js'
import * as actions from './receivableStatementActions.js'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
